export default __webpack_public_path__ + "static/media/YAMP.ec8fd8d6.svg";